
import React, {useState} from "react";

import {
  Alert,
  Box,
  Button,
  CircularProgress
} from "@mui/material";

import AutoFixHighIcon from
  "@mui/icons-material/AutoFixHigh";
import {useAIForm} from "./services";
import AITextAssistant, {AITextAssistRewrite} from "./AITextAssistant";



interface Props<T> {
  formName: string;
  onApply: (fields: T, originalText: string) => Promise<void> | void;
  disabled?: boolean;
  rewriteText?: AITextAssistRewrite;
}

export function AIFormAssistant<T>({
  formName,
  onApply,
  disabled = false,
  rewriteText
}: Props<T>) {

  const [text, setText] = useState("");
  const [message, setMessage] = useState("");

  const ai = useAIForm<T>(formName);

  const handleInterpret = async () => {
    try {
      setMessage("");
      const originalText = text.trim();
      const response = await ai.interpret(originalText);
      await onApply(response.fields, originalText);
      setMessage(
        response.warnings.length
          ? response.warnings.join(". ")
          : "Dati interpretati. Verifica il modulo."
      );
    } catch {
      // L'errore di interpretazione e gestito dall'hook.
    }
  };

  return (
    <Box>
      <AITextAssistant
        textFieldId="ai-activity-description"
        label="Descrivi attività"
        placeholder="Scrivi o detta cosa hai fatto..."
        rows={3}
        maxLength={2000}
        value={text}
        onChange={setText}
        rewriteText={rewriteText}
        disabled={disabled || ai.loading}
      />

      <Button
        sx={{mt: 2}}
        variant="contained"
        startIcon={
          ai.loading
            ? <CircularProgress size={18} />
            : <AutoFixHighIcon />
        }
        onClick={handleInterpret}
        disabled={
          disabled || ai.loading || !text.trim()
        }
      >
        {ai.loading
          ? "Interpretazione..."
          : "Compila con AI"}
      </Button>

      {(message || ai.error) && (
        <Alert
          severity={ai.error ? "error" : "info"}
          sx={{mt: 2}}
        >
          {ai.error || message}
        </Alert>
      )}
    </Box>
  );
}
